import React from 'react';
import { FDStack } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const RoadmapDeliverableStat = ({ value = '', label = '' }) => {
  return (
    <FDStack direction={'column'}>
      <Text value={label} color={'fdTextPrimary'} weight={'bold'} variant={'h5'} align={'left'} />
      <Text value={value} color={'fdTextPrimary'} weight={'medium'} variant={'h5'} align={'left'} />
    </FDStack>
  );
};

export { RoadmapDeliverableStat };
